import css from '@/components/ui/shared/Table/Table.module.css';
import type { CellAlign, HideBelow } from '@/components/ui/shared/Table/types';
import { classNames } from '@/utils/helpers/classNames';
import type { CSSProperties, ReactNode } from 'react';

export interface CellProps {
  width?: string;
  align?: CellAlign;
  hideBelow?: HideBelow;
  className?: string;
  children?: ReactNode;
}

export function cellClassName(
  base: string,
  { width, align, hideBelow, className }: Omit<CellProps, 'children'>
): string {
  return classNames({
    [base]: true,
    [css.cellGrow]: !width && !className,
    [css.alignCenter]: align === 'center',
    [css.alignRight]: align === 'right',
    [css.hideMd]: hideBelow === 'md',
    [css.hideSm]: hideBelow === 'sm',
    [className ?? '']: Boolean(className)
  });
}

export function cellStyle(width?: string): CSSProperties | undefined {
  return width ? { flex: `0 0 ${width}` } : undefined;
}

export function Cell({ width, align, hideBelow, className, children }: CellProps) {
  return (
    <div
      role="cell"
      className={cellClassName(css.cell, { width, align, hideBelow, className })}
      style={cellStyle(width)}
    >
      {children}
    </div>
  );
}
